import Link from 'next/link';
import { Popover } from 'antd';
import Avatar from 'react-avatar';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { useAuth } from '@lib/auth';
import { RootState } from '@lib/redux.lib/store';
import { EverysetUser } from '@lib/types/user.types';
import theme from '@styles/theme';

type ProfileProps = {
  impersonatedUserData: EverysetUser;
  popoverTrigger?: 'click' | 'hover';
};

const Profile = ({
  impersonatedUserData,
  popoverTrigger,
}: ProfileProps): JSX.Element => {
  const userProfile = useSelector((state: RootState) => state.app.user.profile);

  const { logout } = useAuth();

  const getAvatarPhotoUrl = () => {
    if (impersonatedUserData) return impersonatedUserData.profile_photo?.url;
    return userProfile?.profile_photo?.url;
  };
  const avatarPhotoUrl = getAvatarPhotoUrl();

  const getUserDisplayName = () => {
    const dataToUse = impersonatedUserData || userProfile;
    return dataToUse?.first_name?.concat('  ')?.concat(dataToUse?.last_name);
  };
  const userDisplayName = getUserDisplayName();

  return (
    <Popover
      overlayClassName='pop-profile-menu'
      placement='bottom'
      overlayStyle={{
        padding: 16,
        whiteSpace: 'nowrap',
      }}
      trigger={popoverTrigger} // it is fine to be undefined
      content={
        <ProfileMenu>
          <Link href='/profile' passHref legacyBehavior>
            <a>Profile</a>
          </Link>
          <Link href='/Accounts/MyAccount' passHref legacyBehavior>
            <a>Settings</a>
          </Link>
          <a onClick={logout}>Log Out</a>
        </ProfileMenu>
      }
    >
      <ProfileAvatar>
        {avatarPhotoUrl ? (
          <Avatar
            round={true}
            color={theme.palette.primary[0]}
            size='35'
            src={avatarPhotoUrl}
            style={{
              cursor: 'pointer',
            }}
          />
        ) : (
          <Avatar
            round={true}
            color={theme.palette.primary[0]}
            size='35'
            name={userDisplayName}
            style={{
              cursor: 'pointer',
            }}
          />
        )}
      </ProfileAvatar>
    </Popover>
  );
};

const ProfileAvatar = styled.div`
  cursor: pointer;

  img {
    object-fit: cover;
  }
`;
const ProfileMenu = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  a {
    margin: 0;
    font-size: 14px;
    line-height: ${(props) => props.theme.palette.textLineHeight[3]};
    color: black;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  span {
    margin-right: 10%;
  }
`;

export default Profile;
